module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","imprint":"Impressum"},"en":{"back":"Back","imprint":"Imprint"}}')
  delete Component.options._Ctor
}
